
import React from 'react';
import { Helmet } from 'react-helmet-async';
import GameHero from '../components/time-shooter-3/GameHero';
import GameDescription from '../components/time-shooter-3/GameDescription';
import GameFeatures from '../components/time-shooter-3/GameFeatures';
import GameGuide from '../components/time-shooter-3/GameGuide';
import GameFAQ from '../components/time-shooter-3/GameFAQ';
import GameWeapons from '../components/time-shooter-3/GameWeapons';
import GameMissions from '../components/time-shooter-3/GameMissions';
import GameTips from '../components/time-shooter-3/GameTips';

const TimeShooter3 = () => {
  return (
    <>
      <Helmet>
        <title>Time Shooter 3 Unblocked - Free Online SWAT FPS Game</title>
        <meta 
          name="description" 
          content="Play Time Shooter 3 Unblocked free online! Experience intense SWAT action in this first-person shooter game with multiple missions and weapons. No download needed!" 
        />
        <meta name="keywords" content="Time Shooter 3 Unblocked, free online shooter, SWAT game, first person shooter unblocked, browser FPS game" />
        <link rel="canonical" href="https://pokedle.com/time-shooter-3" />
      </Helmet>

      <div className="bg-gradient-to-b from-slate-900 via-indigo-900 to-purple-900 text-white min-h-screen">
        <GameHero />
        
        <div className="container mx-auto px-4 py-8">
          {/* Game iframe container */}
          <div className="my-10" id="play-now">
            <h2 className="text-3xl font-bold mb-6 text-center text-purple-300 drop-shadow-lg">Play Time Shooter 3 Unblocked</h2>
            <div className="game-wrapper bg-black rounded-xl shadow-2xl overflow-hidden border-4 border-purple-500" style={{ aspectRatio: '16/9', maxHeight: '80vh' }}>
              <iframe 
                src="https://mathgames66.github.io/games/html5/timeshooter3swat/" 
                style={{ width: '100%', height: '100%' }} 
                frameBorder="0" 
                allow="gamepad *;"
                title="Time Shooter 3 SWAT Game"
              ></iframe>
            </div>
          </div>
          
          <GameDescription />
          <GameFeatures />
          <GameWeapons />
          <GameMissions />
          <GameGuide />
          <GameTips />
          <GameFAQ />
        </div>
      </div>
    </>
  );
};

export default TimeShooter3;
